// Local, static 501 checkout / strategy engine — no API.
// Standard 3-dart bogey numbers that have NO 3-dart finish.
const BOGEYS = new Set([169, 168, 166, 165, 163, 162, 159]);

// Scoring darts in preference order: trebles high-first, then high singles, 25, bull.
function scorers() {
  const list = [];
  const order = [20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  order.forEach((n) => list.push({ label: `T${n}`, val: n * 3 }));
  order.forEach((n) => list.push({ label: `${n}`, val: n }));
  list.push({ label: "25", val: 25 });
  list.push({ label: "BULL", val: 50 });
  return list;
}
const SCORERS = scorers();

function asDouble(v) {
  if (v === 50) return { label: "BULL", val: 50 };
  if (v > 0 && v % 2 === 0 && v / 2 >= 1 && v / 2 <= 20) return { label: `D${v / 2}`, val: v };
  return null;
}

// Find a checkout route ending on a double, preferring T20/T19 first darts.
function checkoutRoute(rem, dartsLeft) {
  if (rem < 2 || rem > 170) return null;
  if (dartsLeft >= 1) {
    const d = asDouble(rem);
    if (d) return [d];
  }
  if (dartsLeft >= 2) {
    const GOOD = new Set([40, 32, 36, 20, 16, 24, 8, 50]);
    for (const onlyGood of [true, false]) {
      for (const s of SCORERS) {
        const left = rem - s.val;
        if (left <= 0) continue;
        const d = asDouble(left);
        if (d && (!onlyGood || GOOD.has(d.val))) return [s, d];
      }
    }
  }
  if (dartsLeft >= 3) {
    for (const s1 of SCORERS) {
      for (const s2 of SCORERS) {
        const left = rem - s1.val - s2.val;
        if (left <= 0) continue;
        const d = asDouble(left);
        if (d) return [s1, s2, d];
      }
    }
  }
  return null;
}

// A setup aim when no direct finish exists (bogey / too high / awkward).
function setupAim(rem) {
  // Prefer leaving a double-friendly number for the next visit.
  const preferredLeaves = [40, 32, 36, 24, 16, 8, 20, 50, 60, 48, 56, 64];
  for (const target of preferredLeaves) {
    const s = SCORERS.find((x) => x.val === rem - target);
    if (s) return { aim: s.label, note: `Leaves ${target}` };
  }
  for (const s of SCORERS) {
    const left = rem - s.val;
    if (left >= 2 && !BOGEYS.has(left) && checkoutRoute(left, 3)) {
      return { aim: s.label, note: `Leaves ${left}` };
    }
  }
  return { aim: "T20", note: "Keep scoring" };
}

// Main coach tip for the current remaining and darts left in the visit.
export function coachTip(remaining, dartsLeft) {
  if (remaining <= 1) return null;
  if (remaining > 170 || BOGEYS.has(remaining)) return setupAim(remaining);

  const route = checkoutRoute(remaining, dartsLeft);
  if (route) {
    const aim = route[0].label;
    if (route.length === 1) return { aim, note: "For the win" };
    const after = remaining - route[0].val;
    return { aim, note: `Then ${route.slice(1).map((r) => r.label).join(" ")} (${after})` };
  }
  return setupAim(remaining);
}
